import { Breakpoints } from '../breakpoints/breakpoints';
import { DragBar } from '../drag-bar/drag-bar';
import { KSUtility } from '../global/global';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.bar-carousel',
        slides: '.bar-carousel__slides',
        slide: '.bar-carousel__slide',
        bar: '.bar-carousel__bar',
        controlBtn: '.drag-bar__control-btn',
    },
    classNames: {

    },
    dataAttributes: {

    },

    sliderConfig: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 750,
        waitForAnimate: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        // swipeToSlide: true,
        mobileFirst: true,
        autoplay: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2.1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: Breakpoints.BREAKPOINTS.LG,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
        ],
    },
    easeTime: 0.2,
    sliderConfigDuo: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 750,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        // swipeToSlide: true,
        mobileFirst: true,
        autoplay: false,
        variableWidth: false,
        // responsive: [

        //     {
        //         breakpoint: 992,
        //         settings: 'unslick'
        //     },
        // ],
    },
    easeTime: 0.2,
};

class BarCarousel {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._isSlider = false;
        this._currentIndex = 0;
    }

    init() {
        this._elements = this._getDomElements();
        this._initBar();
        this._addEventListener();
        this._setSliderState();

        this._$rootElement.addClass('bar-carousel--' + this._elements.$slide.length);
        this._elements.$bar.addClass('bar-carousel__bar--' + this._elements.$slide.length);
    }

    _getSliderConfig() {
        if (this._$rootElement.hasClass('bar-carousel--2')) {
            return config.sliderConfigDuo;
        } else {
            return config.sliderConfig;
        }
    }

    _setSliderState() {
        if (Breakpoints.isBreakpointOrLarger('lg')) {
            if (this._elements.$slide.length > 3) {
                if (!this._elements.$slides.hasClass('slick-initialized')) {
                    this._elements.$slides.slick(this._getSliderConfig());
                }

                this._elements.$bar.show();
            } else {
                if (this._elements.$slides.hasClass('slick-initialized')) {
                    this._elements.$slides.slick('unslick');
                }

                this._elements.$bar.hide();
            }
        } else {
            if (this._elements.$slide.length === 1) {
                this._elements.$bar.hide();
            } else if (this._elements.$slide.length === 2) {
                if (Breakpoints.isBreakpointOrLarger('md')) {
                    this._elements.$bar.hide();
                } else {
                    if (!this._elements.$slides.hasClass('slick-initialized')) {
                        this._elements.$slides.slick(this._getSliderConfig());
                    }
                    this._elements.$bar.show();
                }
            } else if (this._elements.$slide.length === 2) {
                if (Breakpoints.isBreakpointOrLarger('md')) {
                    this._elements.$bar.hide();
                } else {
                    if (!this._elements.$slides.hasClass('slick-initialized')) {
                        this._elements.$slides.slick(this._getSliderConfig());
                    }
                    this._elements.$bar.show();
                }
            } else {
                if (!this._elements.$slides.hasClass('slick-initialized')) {
                    this._elements.$slides.slick(this._getSliderConfig());
                }

                this._elements.$bar.show();
            }
        }
    }

    _getDomElements() {
        return {
            $slides: this._$rootElement.find(config.selectors.slides),
            $slide: this._$rootElement.find(config.selectors.slide),
            $bar: this._$rootElement.find(config.selectors.bar),
        };
    }

    _addEventListener() {
        const smartedit = $('body').data('smartedit');
        // edit-area


        const _this = this;

        this._elements.$slides.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            console.log('beforeChange', event);

            if (event.target !== _this._elements.$slides[0]) return;

            const $bar = _this._elements.$bar.find(DragBar.getClassname());
            DragBar.setIndex($bar, nextSlide);
            this._currentIndex = nextSlide;
        });

        if (smartedit !== true && smartedit !== 'true') {
            // eslint-disable-next-line func-names
            this._elements.$slide.on('click', async function () {
                const url = $(this).data('url');
                const id = $(this).data('id');

                if (!url || !id) return;

                await KSUtility.showProductOverlay(url, id);

                // eslint-disable-next-line no-console

                // register click listener to init contact app
                // eslint-disable-next-line func-names
                $(`#productOverlay-${id}`).find('*[data-specialist]').on('click', function (e) {
                    e.preventDefault();
                    // eslint-disable-next-line no-console
                    const $el = $(this);

                    const speciality = $el.data('specialist');
                    const tabIndex = $el.data('tab-index') || 0;
                    const prefilledSpeciality = $el.data('prefilled-speciality') || '';

                    // eslint-disable-next-line no-console

                    KSUtility.initContactApp(speciality, tabIndex, prefilledSpeciality);
                });
            });
        }

        this._elements.$slides.on('mousedown', () => {
            console.log('mousedown');
            // Drag start logic
            // ...

            // Event to end drag, may want to include touchend events
            _this._elements.$slides.one('mouseup', () => {
                _this._elements.$slides.off('mousemove');
                // Drag stop logic
                // ...
            }).on('mousemove', () => {
                // Logic for dragging, can get mouse position
                // will probably want to throttle
                // possibly include touchmove events also

                for (let index = 0; index < document.querySelectorAll('.bar-carousel__slide-outer').length; index++) {
                    const element = document.querySelectorAll('.bar-carousel__slide-outer')[index];
                    element.style['pointer-events'] = 'none';
                }
            });
        });

        this._elements.$slides.on('mouseup', () => {
            console.log('mouseup');

            for (let index = 0; index < document.querySelectorAll('.bar-carousel__slide-outer').length; index++) {
                const element = document.querySelectorAll('.bar-carousel__slide-outer')[index];
                element.style['pointer-events'] = 'auto';
            }
        });

        Breakpoints.onBreakpointChange(() => {
            this._setSliderState();
            this._initBar();

            const $bar = this._elements.$bar.find(DragBar.getClassname());
            DragBar.setIndex($bar, this._currentIndex);
        })
    }

    _initBar() {
        // create bar and append into dom
        let barHtml;

        if (Breakpoints.isBreakpointOrLarger('lg')) {
            if (this._elements.$slide.length - 2 > 0) {
                barHtml = DragBar.createHtml(this._elements.$slide.length - 2);
            } else {
                barHtml = DragBar.createHtml(this._elements.$slide.length);
            }
        } else if (Breakpoints.isBreakpointOrLarger('md')) {
            if (this._elements.$slide.length - 1 > 0) {
                barHtml = DragBar.createHtml(this._elements.$slide.length - 1);
            } else {
                barHtml = DragBar.createHtml(this._elements.$slide.length);
            }
        } else {
            barHtml = DragBar.createHtml(this._elements.$slide.length);
        }

        this._elements.$bar.html(barHtml);

        // select bar and register callback
        const $bar = this._elements.$bar.find(DragBar.getClassname());

        DragBar.init($bar, (index) => {
            this._currentYear = index;

            const interval = setInterval(() => {
                this._elements.$slides.slick('slickGoTo', index);
                clearInterval(interval);
            }, 0);
        });

         // Delay setting the control button width until the DOM is ready
    setTimeout(() => {
        this._setControlBtnWidth();
    }, 0);
    }

    _setControlBtnWidth() {
        const $bar = this._elements.$bar.find(DragBar.getClassname());
        const controlBar = $bar.find(config.selectors.controlBtn);

        const slideCount = this._elements.$slide.length;
        let calculatedWidth;
      
        if (Breakpoints.isBreakpointOrLarger('lg')) {
            calculatedWidth = $bar.width() / (slideCount - 2);
        } else if (Breakpoints.isBreakpointOrLarger('md')) {
            calculatedWidth = $bar.width() / (slideCount - 1);
        } else {
            calculatedWidth = $bar.width() / slideCount;
        }
        controlBar.width(calculatedWidth)
    }
    // _initBar() {
    //     // create bar and append into dom
    //     const barHtml = DragBar.createHtml(this._elements.$slide.length, 2);
    //     this._elements.$bar.html(barHtml);

    //     // select bar and register callback
    //     const $bar = this._elements.$bar.find(DragBar.getClassname());

    //     DragBar.init($bar, (index) => {

    //         this._elements.$slides.slick('slickGoTo', index);
    //     });
    // }
}

moduleRegistry.registerModule('BarCarousel', BarCarousel);
moduleRegistry.autoApplyModule('BarCarousel', config.selectors.root);
